import './index.scss'
$("#nav2").addClass("active");
$(".play").click(function() {
    var video = $("#myVideo"); // 使用jQuery对象
    video[0].play();
    $(".video .title").hide();
})

$(".customize-nav ul li").eq(0).addClass("active");
$(".customize-list .content").eq(0).addClass("active");
$(".customize-nav ul li").click(function() {
    let index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $(".customize-list .content").eq(index).addClass('active').siblings().removeClass('active');
})
